import { getConversation } from "@/gen_src/proto/chalk/agent/v1/conversation-AgentConversationService_connectquery";
import { useRouteInfo } from "@/utils/hooks/url/use-route-info";
import { useQuery } from "@connectrpc/connect-query";
import { useMemo } from "react";

const NO_BREADCRUMB_LABELS: Readonly<Record<string, string>> = {};

/**
 * Breadcrumb label for the agent-conversation detail routes, whose URL param is
 * an opaque id: `/agent-conversations/[conversationId]` and its `/artifacts`
 * sub-route. The label is "" until the conversation loads, which suppresses the
 * crumb so the raw id never flashes; a conversation with no title falls back to
 * the same "Untitled conversation" wording the conversations list uses.
 */
export const useAgentConversationBreadcrumbLabels = (): Readonly<Record<string, string>> => {
  // conversationId only exists in the URL on the detail routes, so its presence
  // is the route check.
  const { conversationId } = useRouteInfo();
  // Same request the detail page itself issues, so this reads from the shared
  // query cache instead of fetching the conversation a second time.
  const conversationQuery = useQuery(
    getConversation,
    conversationId != null ? { id: conversationId } : undefined,
    { enabled: conversationId != null },
  );
  const conversation = conversationQuery.data?.conversation;
  const label = conversation == null ? "" : conversation.title || "Untitled conversation";
  return useMemo(
    () => (conversationId == null ? NO_BREADCRUMB_LABELS : { conversationId: label }),
    [conversationId, label],
  );
};
